"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATIC_CONTENT_KIND = void 0;
/**
 * #712 — The two kinds of STATIC editorial text an urban study prints.
 *
 * A study's other editorial text is dynamic: a node's content and its glossary
 * note (#675) print only when that node was answered. These two print in EVERY
 * report, whatever the questionnaire said, and are written once in the tools
 * area rather than against a rule.
 *
 * They share one table (`urban_analysis_static_contents`) because they are the
 * same shape — a heading and a rich-text body — and differ only in where the
 * report puts them. The values are the `kind` column's, so this module is the
 * single source of truth for the tool that writes them, the report that prints
 * them, and the CHECK constraint that guards them.
 */
exports.STATIC_CONTENT_KIND = {
    /**
     * The paragraph that opens every study, printed immediately after the plot
     * map. At most one row — a partial unique index enforces it.
     */
    PREAMBLE: 'PREAMBLE',
    /**
     * A definition printed in every study, after the notes the answered rules
     * brought in. Any number of rows, ordered by `display_order`.
     */
    GLOSSARY: 'GLOSSARY',
};
//# sourceMappingURL=staticContent.js.map